import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Link from '@lichtblick/link';
import themeClass from '@lichtblick/photon/theme/theme.module.scss';
import classNames from 'classnames';
import styles from './box-cta.module.scss';
import { texts } from './box-cta.texts';
export const BoxCTA = (props)=>{
    const { ariaLabel, as, className, 'data-dd-action-name': ddAction, 'data-testid': testId, leftSlot, size = 'large', tabIndex, theme = 'light', variant = 'primary', wide } = props;
    const children = 'children' in props ? props.children : undefined;
    const rightSlot = 'rightSlot' in props ? props.rightSlot : undefined;
    const ctaClasses = classNames('box-cta', styles.cta, styles[variant], styles[size], wide && styles.wide, theme === 'dark' && themeClass.dark, className);
    if (as === 'a') {
        const { download = false, href, onClick, target } = props;
        return /*#__PURE__*/ _jsxs(Link, {
            "aria-label": ariaLabel,
            className: ctaClasses,
            "data-dd-action-name": ddAction,
            "data-testid": testId,
            download: download,
            href: href,
            onClick: onClick,
            tabIndex: tabIndex,
            target: target,
            children: [
                leftSlot && /*#__PURE__*/ _jsx("span", {
                    className: styles.slot,
                    children: leftSlot
                }),
                children && /*#__PURE__*/ _jsx("span", {
                    className: styles.text,
                    children: children
                }),
                rightSlot && /*#__PURE__*/ _jsx("span", {
                    className: styles.slot,
                    children: rightSlot
                })
            ]
        });
    }
    const { disabled, formId, loading, onClick, type } = props;
    return /*#__PURE__*/ _jsxs("button", {
        "aria-label": ariaLabel,
        className: classNames(ctaClasses, loading && styles.loading),
        "data-dd-action-name": ddAction,
        "data-testid": testId,
        disabled: disabled || loading,
        form: formId,
        onClick: onClick,
        tabIndex: tabIndex,
        type: type,
        children: [
            leftSlot && /*#__PURE__*/ _jsx("span", {
                className: styles.slot,
                children: leftSlot
            }),
            children && /*#__PURE__*/ _jsx("span", {
                className: styles.text,
                children: loading ? texts.label.loading : children
            }),
            rightSlot && /*#__PURE__*/ _jsx("span", {
                className: styles.slot,
                children: rightSlot
            })
        ]
    });
};

//# sourceMappingURL=box-cta.js.map